import { render, staticRenderFns } from "./entry-info2.vue?vue&type=template&id=2effa6f0&"
import script from "./entry-info2.vue?vue&type=script&lang=js&"
export * from "./entry-info2.vue?vue&type=script&lang=js&"
import style0 from "./entry-info2.vue?vue&type=style&index=0&id=2effa6f0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports